<div class="container" *ngIf="isRequired">
    <div class="row">
        <div class="col-24">
            <h1>Email Enrollment</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-24">

        </div>
    </div>
    <div class="reference-list row">
        <div class="reference-list">

            <div class="list-box">

                <p *ngIf="for2022">
                    IMPORTANT: Email Enrollment for 2022 is no longer available. 
                </p>
                <p *ngIf="fortemp2023">

                    IMPORTANT: A new process for Email Enrollment will be available for the 2023 Plan Year. Instructions for this new process will be posted on October 15, 2022.
                </p>

                <p *ngIf="for2023">
                    IMPORTANT: A new process for Email Enrollment is available for the 2023 Plan Year. Please find instructions for how to leverage ThinkAgent’s personalized URL (PURL) below.
                </p>
                <ul *ngIf="for2023">
                    <li>
                        <a class="mp4" target="_blank" href="https://storage.googleapis.com/thinkagent_resource/Training/Profile%20And%20PURL.mp4">Profile & PURL Instructional Video</a>
                    </li>
                    <li>
                        <a class="pdf" target="_blank" href="https://storage.googleapis.com/thinkagent_resource/Training/Think%20Agent%20PURL%20Dos%20%26%20%20Donts.pdf">Personalized URL Do’s & Don’ts PDF</a>

                    </li>


                </ul>
            </div>

        </div>
    </div>
</div>
<div id="uxMessageLabel" *ngIf="haserror">
    <div class="row">
        <div class="col-24">
            <p class="bottom-20"><strong>Note:</strong> Your access to Email Enrollment is temporarily denied for the following reason(s):</p>
            <!--<p *ngIf="trainingMsg" class="bottom-10">You have not completed the {{planYear}} certification training course. To access Email Enrollment, you must first complete the <a class="link" (click)="GetTrainingURL()" class="link-button" target='_blank'>Online Training  </a>.</p>-->
            <p *ngIf="trainingMsg" class="bottom-10">
                You have not completed the necessary certification training course.<br />
                For additional information on training, please visit the <a (click)="GetTrainingURL()">Training and Certification</a> page.
            </p>
            <p *ngIf="backgroundMsg" class="bottom-10">Please note that you will not be be able to access this page further until SilverScript completes processing your background check.</p>
            <p *ngIf="trainingFailedMsg" class="bottom-20">You have failed the {{planYear}} certification training course.</p>
            <p *ngIf="licencemsg" class="bottom-20">You do not have a valid state license.</p>
        </div>
    </div>
</div>
<div class="container" *ngIf="validAgent">
    <div class="row">
        <div class="col-24">
            <h1>Email Enrollment</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
        
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <p class="red-text">IMPORTANT: Please make sure you are in the applicable plan year before sending your client the email enrollment link. You can change the plan year at the top left of the page.</p>
        </div>
    </div>
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngIf="licenseError"><button [innerHtml]="licenseError"></button></li>
                    <li *ngIf="beneficiaryNameError"><button>{{beneficiaryNameError}}</button></li>
                    <li *ngIf="specialCharacterBeneficiaryNameError"><button>{{specialCharacterBeneficiaryNameError}}</button></li>
                    <li *ngIf="beneficiaryEmailError"><button>{{beneficiaryEmailError}}</button></li>
                    <li *ngIf="specialCharacterbeneficiaryEmailError"><button>{{specialCharacterbeneficiaryEmailError}}</button></li>
                    <li *ngIf="stateSelectError"><button>{{stateSelectError}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="hasEmailError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li><button>{{EmailError}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isSuccess">
        <div class="col-24">
            <p class="bottom-20"></p>
            <div class="alert success">
                <p><em>Thank you!</em></p>
                <ul>
                    <li>{{emailSendConfirmation}}</li>
                </ul>

            </div>
        </div>
    </div>
    <form (keydown)="onKeyDown($event)">
        <fieldset>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Name of the prospective beneficiary:'"
                                            id="beneficiaryName"
                                            [maxlength]="150"
                                            (onValueChange)="emailSubmitForm.BeneficiaryName = $event"
                                            [text]="emailSubmitForm.BeneficiaryName">
                        </ValidatedTextField>
                    </div>
                </div>
                <!--<div class="col-8">
                    <p class="bottom-20"></p>
                    <div class="errorStyle">{{beneficiaryNameError}}</div>
                    <div class="errorStyle">{{specialCharacterBeneficiaryNameError}}</div>
                </div>-->
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedTextField [label]="'Email address of the prospective beneficiary:'"
                                            id="beneficiaryEmailAddresss"
                                            [maxlength]="60"
                                            (onValueChange)="emailSubmitForm.BeneficiaryEmail = $event"
                                            [text]="emailSubmitForm.BeneficiaryEmail">
                        </ValidatedTextField>
                    </div>
                </div>
                <!--<div class="col-8">
                    <p class="bottom-20"></p>
                    <div class="errorStyle">{{beneficiaryEmailError}}</div>
                    <div class="errorStyle">{{specialCharacterbeneficiaryEmailError}}</div>
                </div>-->
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <ValidatedDropDown class="wide"
                                           [label]="'State of residence of the prospective beneficiary:'"
                                           [selectedValue]="emailSubmitForm.State"
                                           [disabled]="false"
                                           [options]="states"
                                           (onValueChange)="emailSubmitForm.State= $event;checkLicense()">
                        </ValidatedDropDown>
                    </div>
                </div>
                <!--<div class="col-10">
                    <p class="bottom-20"></p>
                    <div class="errorStyle">{{stateSelectError}}</div>
                </div>-->
            </div>
            <div class="row">
                <div class="col-16">
                    <p>   <strong>To send the enrollment email to the prospect, you need to agree to the following:</strong></p>
                    <p class="bottom-20">This email address was provided to me by the prospect and was not rented, purchased or obtained through any type of directory. I have spoken with prospect, explained the SilverScript Prescription Drug Plans and the prospect has requested an enrollment email.</p>
                </div>
            </div>

            <div class="row">
                <div class="col-4">
                    <div class="bottom-20">

                        <ValidatedRadioButtonGroup id="radio1"
                                                   [options]="options"
                                                   radioGroupName="radio-button-group"
                                                   (onValueChange)="selectedRbtn($event)">
                        </ValidatedRadioButtonGroup>
                    </div>
                </div>
                <!--<div class="col-10">
                    <p class="bottom-20"></p>
                    <div class="errorStyle">{{radioCheckError}}</div>
                </div>-->
            </div>

        </fieldset>
        <div class="row">
            <div class="col-24">
                <button id="sendEmail" class="button primary" [disabled]="!(enableButton() && enableSubmit )" (click)="submitForm()">Send Email</button>
            </div>
        </div>
    </form>

</div>












